<script setup lang="ts">
import { useAuthSession } from '@hb/auth-client';
import { isSupportedLocale } from '@hb/i18n';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * The shell. It holds no layout of its own - the signed-out screens draw their
 * own card and the signed-in ones their own chrome - so all it does is keep the
 * interface language in step with the account.
 */
const session = useAuthSession();
const { locale } = useI18n();

// The browser's language is the starting point; the account's preference wins
// as soon as there is one, because it is also the language their email is
// written in and the two disagreeing is worse than either being wrong.
watch(
  () => session.user.value?.locale,
  (preferred) => {
    if (preferred && isSupportedLocale(preferred)) locale.value = preferred;
  },
  { immediate: true },
);
</script>

<template>
  <RouterView />
</template>
